





































































































import { SelectWings, DatePickerWings, FastDateGroupWings, NumberWings } from "wings-ui-components";
import BaseFilter from "@/components/Filter/BaseFilter";
import { CallGroupIncomingFilterParams } from "@/store/call/statistic/types";
import { beginningOfCurrentDay, currentDate, dateFilter } from "@/utils/date-util";
import { Component, PropSync, Watch } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {SelectWings, DatePickerWings, FastDateGroupWings, NumberWings},
  filters: {dateFilter}
})
export default class CallGroupFilter extends BaseFilter<CallGroupIncomingFilterParams> {
  @PropSync("show") is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: CallGroupIncomingFilterParams;

  @Mutation('setCallStatisticGroupIncoming') setStatistic: any

  @Getter("callGroupByIncoming") groupByList: any;
  @Getter("callGroupByOptionallyIncoming") groupByOptionallyList: any;

  @Action("getCallStatisticGroupIncoming") actionGetItems: any;
  @Action("exportCallStatisticGroupIncoming") actionExport: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): CallGroupIncomingFilterParams {
    return new CallGroupIncomingFilterParams(beginningOfCurrentDay(), currentDate(), "day");
  }

  params: object = {transport: MsgTransports.CALL};
  partnersList: any = [];

  // TODO два разные модели требуют отправить в один, надо исправить этот баг
  group_by = null;
  group_by_optionally = null;

  filterKeys: object = {
    "recipient": "incoming_number"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.setStatistic(null)
    this.parseGroupBy()
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  async onFilteredAction() {
    this.setStatistic(null);
    this.mergeGroupBy();
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Group statistics of incoming messages",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        notifyWarning();
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(err);
    }
  }

  // Override
  async doActionExport() {
    this.mergeGroupBy();
    await this.actionExport(this.filter);
  }

  mergeGroupBy() {
    this.filter.group_by = [this.group_by, this.group_by_optionally].filter(item => item).join(',');
    this.$set(this.sendFilter, 'group_by', this.filter.group_by);
    this.$emit('onGroupByChange', {groupBy: this.group_by, optionallyGroupBy: this.group_by_optionally});
  }

  parseGroupBy() {
    if (this.filter.group_by.length == 0) return

    this.filter.group_by.split(',').forEach((item:any) => {
      if (this.groupByList.includes(item)) this.group_by = item;
      else this.group_by_optionally = item;
    })
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterChanged(newVal: CallGroupIncomingFilterParams) {
    this.propFilterClone = newVal;
  }
}
